import { ElementNode, $applyNodeReplacement } from "lexical";

export class ImageNode extends ElementNode {
  __src;
  __alt;

  static getType() {
    return "image";
  }

  static clone(node) {
    return new ImageNode(node.__src, node.__alt, node.__key);
  }

  constructor(src, alt = "", key) {
    super(key);
    this.__src = src;
    this.__alt = alt;
  }

  // ---- DOM RENDERING (no React) ----
  createDOM() {
    const img = document.createElement("img");
    img.src = this.__src;
    if (this.__alt) img.alt = this.__alt;
    img.style.maxWidth = "100%";
    img.style.height = "auto";
    img.draggable = false;
    return img;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__src !== this.__src) dom.src = this.__src;
    if (prevNode.__alt !== this.__alt) dom.alt = this.__alt || "";
    // returning false means Lexical doesn't need to remount
    return false;
  }

  // ---- Behavior hints ----
  isInline() {
    // inline image within text flow; flip to false if you prefer block images
    return true;
  }
  canBeEmpty() {
    return false;
  }
  isIsolated() {
    return true;
  }

  // ---- Import/Export (HTML/JSON) ----
  static importDOM() {
    return {
      img: (domNode) => ({
        conversion: () => {
          const src = domNode.getAttribute("src") || "";
          const alt = domNode.getAttribute("alt") || "";
          return { node: new ImageNode(src, alt) };
        },
        priority: 1,
      }),
    };
  }

  exportDOM() {
    const img = document.createElement("img");
    img.setAttribute("src", this.__src);
    if (this.__alt) img.setAttribute("alt", this.__alt);
    return { element: img };
  }

  static importJSON(json) {
    return new ImageNode(json.src, json.alt || "");
  }

  exportJSON() {
    return {
      type: "image",
      version: 1,
      src: this.__src,
      alt: this.__alt,
    };
  }
}

// Helper to create & replace properly
export function $createImageNode(src, alt = "") {
  return $applyNodeReplacement(new ImageNode(src, alt));
}

export function $isImageNode(node) {
  return node instanceof ImageNode;
}